<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Mi organigrama</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( organigrama  , 'ORGANIGRAMA')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
           
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="organigrama"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >

							    <template v-slot:item.requeridos="{ item }">
                    <v-chip 
                      small
                      color="green"
                      dark
                      label
                      @click="verDetalleRequeridos(  item )"
                    >
                      {{ item.requeridos }}
                    </v-chip>
                  </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialogBaja"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Solicitud de Baja</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<!-- Selecciona el tipo de baja -->
          	<v-col cols="12">
          		<label>Elige un tipo de baja</label>
          		<v-radio-group
					      v-model="editedItem.tipo_baja"
					      row
					      dense
					      hide-details
					    >
					      <v-radio
					        label="Baja programada"
					        :value="1"
					      ></v-radio>
					      <v-radio
					        label="Baja automática"
					        :value="2"
					      ></v-radio>
					    </v-radio-group>	
          	</v-col>

          	<v-col cols="12" v-if="editedItem.tipo_baja == 1">
          		<label>Elige una fecha de baja</label>
              <v-text-field
                v-model="editedItem.fecha_baja"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
          		<label>Redacta el motivo de la baja</label>
              <v-textarea
                v-model="editedItem.motivo_baja"
                label=""
                filled
                hide-details
                dense
                :rows="3"
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRequeridos"
      max-width="1400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Posiciones del puesto
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <b>Puesto: </b> {{ editedItem.puesto }}
            </v-col>  
          </v-row>

          <br/>

          <v-data-table
            :headers="headersRequeridos"
            :items="vacantes_requeridos"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip color="green"  v-if="item.estatus == 1"       small dark >Activo</v-chip>
              <v-chip color="error"  v-else-if="item.estatus == 2"  small dark @click="verBajas( item )">Baja solicitada</v-chip>
              <v-chip color="black"  v-else-if="item.estatus == 3"  small dark @click="verBajas( item )">Rechazado</v-chip>
              <v-chip color="orange" v-else-if="item.estatus == 4"  small dark @click="verBajas( item )">Retenido</v-chip>
              <v-chip color="red"    v-else                 small dark >Vacante</v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon color="red" @click="darBaja( item )" v-if="[1].includes( item.estatus )">mdi-close-box</v-icon>
            </template>
           

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de bajas -->
    <v-dialog
      v-model="dialogVerBaja"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Historial de la baja</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          
          <v-row>
            <v-col cols="12" v-for="( baja, i ) in bajas" :key="i">
              <v-card class="shadowCard">
                <v-card-text>
                  <b>Solicitó</b>: {{ baja.solicito }}<br/>
                  <b>Colaborador</b>: {{ baja.colaborador }}<br/>
                  <b>Fecha</b>: {{ baja.fecha_creacion }}<br/>
                  <b>Tipo Baja</b>: 
                    <span v-if="editedItem.tipo_baja == 1">Baja programada</span>
                    <span v-if="editedItem.tipo_baja == 2">Baja automática</span>
                  <br/>
                  <b>Fecha Baja</b>: {{ editedItem.fecha_baja }}<br/>
                  <b>Motivo</b>: {{ baja.motivo }}<br/>
                  <b>Motivo Rechazo</b>: {{ baja.motivo_rechazo }}<br/>
                  <b>Estatus:</b> 
                    <span v-if="baja.estatus == 0">Pendiente</span>
                    <span v-if="baja.estatus == 1">Cerrado</span>
                  <br/>
                  <br/>
                  <br/>
                </v-card-text>

                <v-card-text v-if="editedItem.estatus == 4  && i == bajas.length - 1" class="black--text">
                  <label><b>Está solicitud está retenida, por favor, acepta o rechaza</b></label>
                  <br/>
                </v-card-text>

                <v-card-text v-if="editedItem.estatus == 3  && i == bajas.length - 1" class="black--text">
                  <label><b>Está solicitud está rechazada, por favor, acepta o rechaza</b></label>
                  <br/>
                </v-card-text>

                <v-card-text v-if="rechazado" class="black--text">
                  <v-row>
                    <!-- Selecciona el tipo de baja -->
                    <v-col cols="12">
                      <label>Elige un tipo de baja</label>
                      <v-radio-group
                        v-model="editedItem.tipo_baja"
                        row
                        dense
                        hide-details
                      >
                        <v-radio
                          label="Baja programada"
                          :value="1"
                        ></v-radio>
                        <v-radio
                          label="Baja automática"
                          :value="2"
                        ></v-radio>
                      </v-radio-group>  
                    </v-col>

                    <v-col cols="12" v-if="editedItem.tipo_baja == 1">
                      <label>Elige una fecha de baja</label>
                      <v-text-field
                        v-model="editedItem.fecha_baja"
                        filled
                        hide-details
                        dense
                        type="date"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <label>Redacta el motivo de la baja</label>
                      <v-textarea
                        v-model="editedItem.motivo_baja"
                        label=""
                        filled
                        hide-details
                        dense
                        :rows="3"
                        auto-grow
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions v-if="editedItem.estatus == 4 && baja.estatus == 1 && i == bajas.length - 1">
                  <v-btn small color="red"     dark class="mr-2" @click="rechazado = true"        v-if="rechazado == false">Rechazar</v-btn>
                  <v-btn small color="success" dark              @click="aceptarRechazo( baja )"  v-if="rechazado == false">Aceptar </v-btn>
                  <v-btn small color="red"     dark class="mr-2" @click="rechazar( baja )"        v-if="rechazado == true" >Enviar petición</v-btn>
                  <v-btn small color="black"   dark class="mr-2" @click="rechazado = false"       v-if="rechazado == true" >Cancelar</v-btn>
                </v-card-actions>

                <v-card-actions v-if="editedItem.estatus == 3 && baja.estatus == 1 && i == bajas.length - 1">
                  <v-btn small color="red"     dark class="mr-2" @click="rechazado = true"        v-if="rechazado == false">Rechazar</v-btn>
                  <v-btn small color="success" dark              @click="aceptarRechazo( baja )"  v-if="rechazado == false">Aceptar </v-btn>
                  <v-btn small color="red"     dark class="mr-2" @click="rechazar( baja )"        v-if="rechazado == true" >Enviar petición</v-btn>
                  <v-btn small color="black"   dark class="mr-2" @click="rechazado = false"       v-if="rechazado == true" >Cancelar</v-btn>
                </v-card-actions>
                
              </v-card>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogVerBaja = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        id_puesto:0,
        id_jefe:0,
        id_turno:0,
        id_plantel:0,
        requeridos:0,
        deleted: 0,
        fecha_creacion: null,
      },

      defaultItem: {
        id_puesto:0,
        id_jefe:0,
        id_turno:0,
        id_plantel:0,
        requeridos:0,
        deleted: 0,
        fecha_creacion: null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      organigrama: [],
      puestos:[],
      planteles:[],
			turnos:[],
      headers: [
        { text: 'Puesto'         , value: 'puesto'      },
        { text: 'Departamento'   , value: 'departamento'},
        { text: 'Jefe directo'   , value: 'puesto_jefe' },
        { text: 'Turno'          , value: 'turno'       },
        { text: 'Plantel'        , value: 'plantel'     },
        { text: 'Autorizados'    , value: 'requeridos'  },
        { text: 'Actions'        , value: 'actions', sortable: false },
      ],
      url:'',

      vacantes_detalles:[],
      dialogDetalles: false,

      headersDetalles: [
        { text: 'Puesto'               , value: 'puesto'                   },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'Actions'              , value: 'actions'                  },
      ],


      editedItemDetalle: {
        idseguimiento_campanias: 0,
        id_sucursal: 0,
        id_puesto: 0,
        id_turno: 0,
        id_coordinadora: 0,
        campania: '',
        resultado_mkt: 0,
        resultado_rh: 0,
        funciona: 0,
        deleted:0,
        fecha_creacion:null,
        fecha_compromiso: null,
        estatus: 1,
        sexo:0,
        cantidad:0,
        fecha_apertura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },

      defaultItemDetalle: {
        idseguimiento_campanias: 0,
        id_sucursal: 0,
        id_puesto: 0,
        id_turno: 0,
        id_coordinadora: 0,
        campania: '',
        resultado_mkt: 0,
        resultado_rh: 0,
        funciona: 0,
        deleted:0,
        fecha_creacion:null,
        fecha_compromiso: null,
        estatus: 1,
        sexo:0,
        cantidad:0,
        fecha_apertura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },

      dialogAddDetalle: false,
      puestosAll: [],

      usuarios: [],

      vacantes_requeridos:[],
      dialogRequeridos: false,

      headersRequeridos:[
        { text: 'Folio'                , value: 'folio'                    },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'Trabajador'           , value: 'trabajador'               },
        { text: 'Estatus'              , value: 'estatus'                  },
        { text: 'Actions'              , value: 'actions', sortable: false },
      ],

      dialogReporte: false,
      dialogBaja: false,
      dialogVerBaja: false,
      bajas: null,
      rechazado: false,
      motivorechazo: '',

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar datos' : 'Editar datos'
      },

      vacantes_detalles_all( ){

        let arreglo = []
        for( const i in this.organigrama){

          const { vacantes, vacantes_detalles } = this.organigrama[i] 
          
          if( vacantes > 0 ){
            arreglo = arreglo.concat( vacantes_detalles )
          }

        }

        return arreglo
      }
    },

    watch: {
      dialogBaja (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      this.url = 'https://escuelakpi.club/documentacionrh/'

      await this.initialize( )
      await this.getPuestos( )
      await this.getPlanteles()
      await this.getTurnos( )
      await this.getUsuarios( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.organigrama = []

        return this.$http.post('mi.organigrama', this.getdatosUsuario ).then(response=>{

        	this.organigrama = response.data
          
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPuestos () {
      	this.cargar = true
        this.puestos = []
        this.puestosAll = []
        return this.$http.get('organigrama.puestos').then(response=>{
          this.puestos = response.data.getPuestos
        	this.puestosAll = response.data.getPuestos
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
        this.cargar = true
        this.usuarios = []
        return this.$http.get('vacantes.list').then(response=>{
          this.usuarios      = response.data.reclutadoras

          console.log( this.usuarios[0] )
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      addVacanteDetalle( ){

        this.cargar = true
        this.editedItemDetalle.id_puesto = this.editedItem.id_puesto 

        // Lo mandapos por el EP
        this.$http.post('seguimiento.vacantes.add', this.editedItemDetalle).then(response=>{
          this.initialize( )
          this.dialogAddDetalle = false
          this.editedItemDetalle = Object.assign({}, this.defaultItemDetalle)
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      updateVacante( item ){

        this.cargar = true
        item.id_puesto = this.editedItem.id_puesto 

        // Lo mandapos por el EP
        this.$http.put('seguimiento.vacantes.update/' + item.idseguimiento_campanias, item).then(response=>{
          this.initialize( )
          this.validarSuccess('Datos actualizados correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      eliminarVacante( item ){

        this.cargar = true
        item.deleted = 1 

        // Lo mandapos por el EP
        this.$http.put('seguimiento.vacantes.update/' + item.idseguimiento_campanias, item).then(response=>{
          this.initialize( )
          this.validarSuccess('Datos actualizados correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
          this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getTurnos( ){
        this.cargar = true
        this.turnos = []
        this.$http.get('seguimiento.turnos').then(response=>{
          this.turnos = response.data
          console.log( this.turnos )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('organigrama.v2/' + this.editedItem.idnuevo_organigrama, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialogBaja = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      verDetalle( item ){
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.vacantes_detalles = item.vacantes_detalles
        this.dialogDetalles = true

      },

      verDetalleRequeridos( item ){
        this.editedIndex         = this.organigrama.indexOf(item)
        this.editedItem          = Object.assign({}, item)
        this.vacantes_requeridos = item.vacantes_requeridos
        this.dialogRequeridos    = true

      },

      async save () {
    		// Iniciar el loader
    		this.cargar = true

      	try{

      		this.editedItem['id_solicita'] = this.getdatosUsuario.iderp 

      		// Realizar la consulta
      		const { data } = await this.$http.post('organigrama.baja', this.editedItem )

      		// Reiniciar todo
      		this.initialize()
        	this.cargar = false
      		this.close()

      	} catch( error ) {

      		this.validarError( error.response.data.message )

      	} finally {
			    this.cargar = false;
			  }

      },

      darBaja( item ){
      	this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem  = Object.assign({}, item)
        this.dialogBaja  = true
      },

      verBajas( item ){
        this.editedIndex         = this.organigrama.indexOf(item)
        this.editedItem          = Object.assign({}, item)
        this.bajas               = item.bajas
        this.dialogVerBaja = true

      },

      async retener( baja ){

        try{


          const payload = {
            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo: this.motivorechazo,
            idsolicitud_bajas: baja.idsolicitud_bajas,
            estatus_baja: 1, // Contestado
            estatus_seguimiento: 4, // Rechazo,
            id_acepta: this.getdatosUsuario.iderp
          }


          const { data } = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false 
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      },

      async aceptarRechazo( baja ){

        try{


          const payload = {

            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo         : this.motivorechazo,
            idsolicitud_bajas      : baja.idsolicitud_bajas,
            estatus_baja           : 1, // Contestado
            estatus_seguimiento    : 0, // Rechazo,
            id_acepta              : this.getdatosUsuario.iderp,
            id_trabajador          : this.editedItem.id_trabajador,
            tipo_baja              : this.editedItem.tipo_baja
          }


          const { data } = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false 
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      },

      async rechazar( baja ){

        try{

          const payload = {
            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo: baja.motivorechazo,
            idsolicitud_bajas: baja.idsolicitud_bajas,
            estatus_baja: 1, // Contestado
            estatus_seguimiento: 2, // Rechazo,
            id_acepta: this.getdatosUsuario.iderp
          }

          this.editedItem['id_solicita'] = this.getdatosUsuario.iderp 

          // Realizar la consulta
          const respuesta  = await this.$http.post('organigrama.baja', this.editedItem )

          const respuesta2 = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false 
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      }
    },
  }
</script>


